
const animations = {
    init()  {

    }
}

export {animations}